import { useState, useCallback } from 'react';
import { get, post, put, del } from '../utils/networkUtils';

export const useBanners = () => {
  const [banners, setBanners] = useState([]);
  const [bannerTypes, setBannerTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBanners = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await get('/admin/banners');
      setBanners(response.banners || []);
      setBannerTypes(response.bannerTypes || []);
      return response;
    } catch (err) {
      console.error('Error fetching banners:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch banners';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const createBanner = useCallback(async (bannerData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await post('/admin/banners', bannerData);
      await fetchBanners(); // Refresh the list
      return response;
    } catch (err) {
      console.error('Error creating banner:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to create banner';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [fetchBanners]);

  const updateBanner = useCallback(async (id, bannerData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await put(`/admin/banners/${id}`, bannerData);
      await fetchBanners(); // Refresh the list
      return response;
    } catch (err) {
      console.error('Error updating banner:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to update banner';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [fetchBanners]);

  const deleteBanner = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await del(`/admin/banners/${id}`);
      await fetchBanners(); // Refresh the list
      return response;
    } catch (err) {
      console.error('Error deleting banner:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to delete banner';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [fetchBanners]);

  return {
    banners,
    bannerTypes,
    loading,
    error,
    fetchBanners,
    createBanner,
    updateBanner,
    deleteBanner,
  };
};
